import { createColumnHelper } from '@tanstack/react-table';
import { QrCodeScanner } from 'assets/icon';
import Config from 'configuration';
import moment from 'moment';
import Utils from 'utils';
import Badge from '../Badge';
import HidenBox from '../HidenBox';
import QrShowBox from '../QrShowBox';

const columnHelper = createColumnHelper();

function formatDate(value) {
    return moment(new Date(value.getValue())).format('DD/MM/YYYY');
}

export const ProductColumns = (intl) => [
    columnHelper.accessor('code', {
        header: intl.messages.productId,
    }),
    columnHelper.accessor('name', {
        header: intl.messages.productName,
    }),
    columnHelper.accessor('created_at', {
        header: intl.messages.dateCreated,
        cell: (e) => {
            return formatDate(e);
        },
    }),
    columnHelper.accessor('qr_code', {
        header: intl.messages.qrCode,
        cell: (e) => <QrShowBox data={e.row.original.code} content={<QrCodeScanner />} />,
        meta: {
            align: 'center',
            class: 'fit-content',
        },
    }),
    columnHelper.accessor('security_code', {
        header: intl.messages.securityCode,
        cell: (e) => <HidenBox content={e.getValue()} />,
        meta: {
            align: 'center',
            class: 'fit-content',
        },
    }),
    columnHelper.accessor('is_scanned', {
        header: intl.messages.activeStatus,
        meta: {
            align: 'center',
            class: 'fit-content',
        },
        cell: (e) => (
            <Badge
                trueIntl={intl.messages.activated}
                falseIntl={intl.messages.notActivated}
                color={'green'}
                isAvailable={e.getValue()}
            />
        ),
    }),
];

export const GinColumns = (intl) => [
    columnHelper.accessor('code', {
        header: intl.messages.ginId,
    }),
    columnHelper.accessor('name', {
        header: intl.messages.ginName,
    }),
    columnHelper.accessor('created_at', {
        header: intl.messages.dateCreated,
        cell: (e) => {
            return formatDate(e);
        },
    }),
    columnHelper.accessor('product_associate', {
        header: intl.messages.linkedProduct,
        meta: {
            align: 'center',
        },
    }),
];

export const ArticleColumns = (intl) => [
    columnHelper.accessor('title', {
        header: intl.messages.title,
        cell: (e) => Utils.truncateString(e.getValue(), 40),
    }),
    columnHelper.accessor('newspaper_office_name', {
        header: intl.messages.link,
        cell: (e) => (
            <a className='btn-link' href={e.getValue()}>
                {Utils.truncateString(e.getValue(), 40)}
            </a>
        ),
    }),
    columnHelper.accessor('display', {
        header: intl.messages.status,
        meta: {
            align: 'center',
            class: 'fit-content',
        },
        cell: (e) => (
            <Badge
                trueIntl={intl.messages.showing}
                falseIntl={intl.messages.hidden}
                color={'blue'}
                isAvailable={e.getValue()}
            />
        ),
    }),
    columnHelper.accessor('created_at', {
        header: intl.messages.dateCreated,
        cell: (e) => {
            return formatDate(e);
        },
    }),
];

export const CertificateColumns = (intl) => [
    columnHelper.accessor('name', {
        header: intl.messages.name,
    }),
    columnHelper.accessor('file_path', {
        header: intl.messages.fileName,
        cell: (e) => (
            <a
                className='btn-link'
                href={Config.domain + e.getValue().substring(1)}
                target='_blank'
                rel='noopener noreferrer'
            >
                {Utils.getLastSplit(e.getValue(), '/')}
            </a>
        ),
    }),
    columnHelper.accessor('description', {
        header: intl.messages.desc,
    }),
    columnHelper.accessor('created_at', {
        header: intl.messages.dateCreated,
        cell: (e) => {
            return formatDate(e);
        },
    }),
];

export const LocationColumns = (intl) => [
    columnHelper.accessor('address', {
        header: intl.messages.address,
    }),
    columnHelper.accessor('description', {
        header: intl.messages.desc,
    }),
    columnHelper.accessor('created_at', {
        header: intl.messages.dateCreated,
        cell: (e) => {
            return formatDate(e);
        },
    }),
];
